import { Vue as _Vue } from 'vue/types/vue'
import { VueModule } from 'vue-modules'
import VueRouter from 'vue-router'
import { Store } from 'vuex'
import { createProfileRoutes } from './router/profile-router'
import { ProfileStore } from '@/modules/profile/store'

export class ProfileModule implements VueModule {
  public readonly name = 'profile';
  constructor (private router: VueRouter, private store: Store<any>) {}

  public install (Vue: typeof _Vue) {
    const routes = createProfileRoutes(this.store)
    this.router.addRoutes(routes)
    this.store.registerModule('profile', ProfileStore)
  }
}
